import { LeavePageAlertProvider } from './components/Form/LeavePageAlert';
import { InitializeProvider } from './providers/InitializeProvider';
import { StackSiderViewProvider } from './providers/StackSiderViewProvider';
import { AppRoutes } from './routes';

export function App() {
  return (
    <InitializeProvider>
      <LeavePageAlertProvider>
        <StackSiderViewProvider>
          <AppRoutes />
        </StackSiderViewProvider>
      </LeavePageAlertProvider>
    </InitializeProvider>
  );
}
